import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f9043a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("查看报告单")
const _hoisted_16 = { id: "badReport" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "坏账准备核销申请报告", -1))
const _hoisted_18 = { class: "tips" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = { class: "tips" }
const _hoisted_22 = { class: "d-flex" }
const _hoisted_23 = { class: "tips name" }
const _hoisted_24 = { class: "tips name" }
const _hoisted_25 = { class: "company" }
const _hoisted_26 = { class: "date" }

import { ref, reactive, onBeforeMount, computed } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import dayjs from 'dayjs'
import { formatNumber, getNumber } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  'POST/bad_debt/sale/declare_bad_debt/query': fetchList,
} = Api

const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_height
} = new tbMix(fetchList)

const searchEle = ref()
const searchObj = reactive({
  owner: '', customer: '', orderNo: '',
})
const searchHandle = () => {
  fetchData(searchObj)
}
searchHandle()

// 预览
const isShowPreview = ref<boolean>(false)
const reportRow = ref<any>({})
const showReport = (row: any) => {
  reportRow.value = row
  // 打开预览dialog
  isShowPreview.value = true
}

const mergeMethod = ({row, columnIndex}: any) => {
  if (row.list) {
    if (columnIndex === 0) {
      return [1, 15]
    } else if(columnIndex <= 14) {
      return [0, 0]
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, { class: "mb-10" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref_key: "searchEle",
              ref: searchEle,
              model: _unref(searchObj),
              inline: "",
              class: "searchBg",
              disabled: _unref(MI_identify)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "订单号:",
                  prop: "orderNo"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(searchObj).orderNo,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchObj).orderNo) = $event)),
                      clearable: "",
                      maxlength: "100",
                      placeholder: "请输入订单号",
                      class: "form-input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "客户名称:",
                  prop: "customer"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(searchObj).customer,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchObj).customer) = $event)),
                      clearable: "",
                      maxlength: "100",
                      placeholder: "请输入客户名称",
                      class: "form-input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "客户经理:",
                  prop: "owner"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(searchObj).owner,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchObj).owner) = $event)),
                      clearable: "",
                      maxlength: "100",
                      placeholder: "请输入客户经理",
                      class: "form-input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _hoisted_1,
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (searchHandle())),
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (searchEle.value.resetFields()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      data: _unref(MI_tableData),
      "row-key": (row) => (row.packageId || row.id),
      "span-method": mergeMethod,
      "row-class-name": ({row}: any) => row.list ? 'gray-row' : '',
      "header-row-class-name": () => 'gray-head',
      "expand-row-keys": [_unref(MI_tableData)[0]?.packageId + ''],
      "max-height": _unref(MI_height) - 30 + 'px',
      class: "mt-10",
      "tree-props": { children: 'list' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "packageName",
          label: "",
          fixed: "",
          width: "100"
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(row.packageName ? `${row.packageName}(${row.sale})【${row.list[0].isEnforced ? '强制': '非强制'}】` : ''), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "订单号",
          prop: "no",
          "show-overflow-tooltip": "",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "订单名称",
          prop: "name",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "客户ID",
          prop: "customerUsername",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "客户名称",
          prop: "customer",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "客户联系人",
          prop: "customerContactor",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "客户经理",
          prop: "owner",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "币种",
          prop: "currency",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          label: "金额",
          prop: "amount",
          align: "right"
        }, {
          default: _withCtx(({row}) => [
            (!row.packageName)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(getNumber)(row.amount)), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_5))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "本位币",
          prop: "standardMoney",
          align: "right"
        }, {
          default: _withCtx(({row}) => [
            (!row.packageName)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(getNumber)(row.standardMoney)), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_7))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "确认坏账时间",
          prop: "confirmTime",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({row}) => [
            (!row.packageName)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(row.confirmTime), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_9))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "申报坏账时间",
          prop: "declareTime",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({row}) => [
            (!row.packageName)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(row.declareTime), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_11))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "坏账金额(CNY)",
          prop: "badDebtAmount",
          "min-width": "130",
          align: "right"
        }, {
          default: _withCtx(({row}) => [
            (!row.packageName)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_unref(getNumber)(row.badDebtAmount)), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_13))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "开始日期",
          prop: "startTime",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "交付日期",
          prop: "deliverTime",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "status",
          label: "订单状态",
          width: "110",
          fixed: "right"
        }, {
          default: _withCtx(({row}) => [
            (!row.packageName)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(row.status), 1))
              : (_openBlock(), _createBlock(_component_el_link, {
                  key: 1,
                  type: "primary",
                  onClick: ($event: any) => (showReport(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "row-key", "row-class-name", "header-row-class-name", "expand-row-keys", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      total: _unref(MI_total),
      background: "",
      small: "",
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[5] || (_cache[5] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[6] || (_cache[6] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-sizes": [30, 50, 100, 300],
      class: "mt-10",
      disabled: _unref(MI_identify),
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "page-size", "currentPage", "disabled", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowPreview.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((isShowPreview).value = $event)),
      top: "10px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("p", _hoisted_18, "我司于 " + _toDisplayString(_unref(dayjs)(reportRow.value.list[0].confirmTime).format('YYYY')) + " 年核销了以下坏账，均与销售确认为无法回收的坏账，明细如下：", 1),
          _createVNode(_component_el_table, {
            data: reportRow.value?.list,
            border: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "订单号",
                prop: "no"
              }),
              _createVNode(_component_el_table_column, {
                label: "订单名称",
                prop: "name"
              }),
              _createVNode(_component_el_table_column, {
                label: "订单金额",
                prop: "amount",
                align: "right",
                formatter: _unref(formatNumber)
              }, null, 8, ["formatter"]),
              _createVNode(_component_el_table_column, {
                label: "币别",
                prop: "currency"
              }),
              _createVNode(_component_el_table_column, {
                label: "本位币金额(CNY)",
                prop: "standardMoney",
                align: "right",
                formatter: _unref(formatNumber)
              }, null, 8, ["formatter"])
            ]),
            _: 1
          }, 8, ["data"]),
          _hoisted_19,
          _hoisted_20,
          _createElementVNode("p", _hoisted_21, "原因：" + _toDisplayString(reportRow.value.list[0].reason), 1),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("p", _hoisted_23, "销售：" + _toDisplayString(`${reportRow.value.sale}(${reportRow.value.saleChName})`), 1),
            _createElementVNode("p", _hoisted_24, "分公司领导：" + _toDisplayString(reportRow.value.saleLeaderChName.join(',')), 1)
          ]),
          _createElementVNode("p", _hoisted_25, "公司：" + _toDisplayString(reportRow.value.list[0].company), 1),
          _createElementVNode("p", _hoisted_26, _toDisplayString(_unref(dayjs)(reportRow.value.declareTime).format('YYYY年MM月DD日')), 1)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})